module.exports = __webpack_public_path__ + "img/icon2.9ca51bfc.png";